import { render, staticRenderFns } from "./TrainingMain.vue?vue&type=template&id=79a21cf4&scoped=true&"
import script from "./TrainingMain.vue?vue&type=script&lang=js&"
export * from "./TrainingMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a21cf4",
  null
  
)

export default component.exports